// © Microsoft Corporation. All rights reserved.
import React, { useState, useEffect } from 'react';
import { Label, Overlay, Stack } from '@fluentui/react';
import Header from '../containers/Header';
import MediaGallery from '../containers/MediaGallery';
import MediaFullScreen from './MediaFullScreen';
import CommandPanel, { CommandPanelTypes } from './CommandPanel';
import { Constants } from '../core/constants';
import {
    headerStyles,
    containerStyles,
    paneStyles,
    hiddenContainerClassName,
    activeContainerClassName,
    loadingStyle,
    overlayStyles
} from './styles/GroupCall.styles';
import {
    Call,
    AudioDeviceInfo,
    VideoDeviceInfo,
    RemoteParticipant,
    CallAgent,
    DeviceManager,
    LocalVideoStream,
    LocalAudioStream
} from '@azure/communication-calling';
import { ParticipantStream } from 'core/reducers/index.js';
import Banner from './Banner';
import DialogBox from './DialogBox';
import { ParticipantModel, ParticipantInfo } from 'Utils/participantInfo';

export interface GroupCallProps {
    userId: string;
    groupId: string;
    call: Call;
    callAgent: CallAgent;
    deviceManager: DeviceManager;
    mic: boolean;
    remoteParticipants: RemoteParticipant[];
    callState: string;
    localVideo: boolean;
    screenShareStreams: ParticipantStream[];
    audioDeviceInfo: AudioDeviceInfo;
    videoDeviceInfo: VideoDeviceInfo;
    audioDeviceList: AudioDeviceInfo[];
    videoDeviceList: VideoDeviceInfo[];
    screenWidth: number;
    shareScreen: boolean;
    setAudioDeviceInfo(deviceInfo: AudioDeviceInfo): void;
    setVideoDeviceInfo(deviceInfo: VideoDeviceInfo): void;
    mute(): void;
    isGroup(): void;
    joinGroup(): void;
    endCallHandler(): void;
    localVideoStream: LocalVideoStream;
    localAudioStream: LocalAudioStream;
    setLocalVideoStream: void;
    setLocalAudioStream: void;
    recordingStatus: string;
    recordingId: string;
    bannerVisiblilty: boolean;
    setBannerVisiblilty(b: boolean): void;
    recordingError: string;
    dialogBoxVisiblilty(b: boolean): void;
    isDialogBoxVisiblile: boolean;
    showMessage: boolean;
    cogbeeMessage: string;
}

declare global {
    var showMessage: boolean;
    var cogbeeMessage: string;
    var commandPanelActive: string;
}

export default (props: GroupCallProps): JSX.Element => {
    const [selectedPane, setSelectedPane] = useState(CommandPanelTypes.None);
    const activeScreenShare = props.screenShareStreams && props.screenShareStreams.length === 1;
    const [bannerMessages, setBannerMessages] = useState({ Header: '', Message: '', LinkText: '' });
    //console.log("COGBEE CallID " + props.call.id);
    const dismissBanner = () => {
        props.setBannerVisiblilty(false);
    };
    const dismissDialogBox = () => {
        props.dialogBoxVisiblilty(false);
    };

    const modelone: ParticipantInfo = ParticipantModel();
    let isMobile = false;
    isMobile = modelone.isMobile == 'true' ? true : false;

    useEffect(() => {
        if (props.recordingStatus === Constants.STARTED) {
            const message =
                props.recordingId === ''
                    ? 'This meeting is being recorded. By joining you are giving consent for this meeting to be recorded.'
                    : 'You are recording this meeting, Be sure to let everyone know they are being recorded.';
            const header = props.recordingId === '' ? 'Recording has started.' : "You're recording";
            //  setBannerMessages({ Header: header, Message: message, LinkText: '' });
        } else if (props.recordingStatus === Constants.STOPPED) {
            // setBannerMessages({
            //    Header: 'Recording is being saved',
            //    Message: 'Recording has stopped. You can find the recording in blob storage.',
            //    LinkText: ''
            //});
        }
        else {

        }
    }, [props.recordingStatus]);

    useEffect(() => {
        if (window.showMessage) {

            setBannerMessages({ Header: '', Message: window.cogbeeMessage, LinkText: '' });
        }
    }, [window.showMessage]);

    return (
        <Stack horizontalAlign="center" verticalAlign="center" styles={containerStyles}>
            <Stack.Item styles={headerStyles}>
                <Header
                    selectedPane={selectedPane}
                    setSelectedPane={setSelectedPane}
                    endCallHandler={(): void => {
                        props.endCallHandler();
                    }}
                    screenWidth={props.screenWidth}
                    localVideoStream={props.localVideoStream}
                    setLocalVideoStream={props.setLocalVideoStream}
                    localAudioStream={props.localAudioStream}
                    setLocalAudioStream={props.setLocalAudioStream}

                />
            </Stack.Item>
            <Stack.Item styles={headerStyles}>
                {props.isDialogBoxVisiblile && props.recordingError !== '' && (
                    <DialogBox
                        message={props.recordingError}
                        isDialogBoxVisiblile={props.isDialogBoxVisiblile}
                        dismissDialogBox={dismissDialogBox}
                    />
                )}
            </Stack.Item>
            <Stack.Item styles={containerStyles}>
                {props.bannerVisiblilty && props.recordingStatus !== '' && (
                    <Banner bannerMessages={bannerMessages} dismissBanner={dismissBanner} timerPopup={() => { dismissBanner }} showAlertBanner={false} isMobile={isMobile} />
                )}

                {
                    props.callState === Constants.CONNECTED && (
                        <Stack className={isMobile ? "MainScreenSection" : ""} horizontal styles={containerStyles}>
                            {isMobile && (
                                <Stack.Item className="ScreenSection" grow styles={activeScreenShare ? activeContainerClassName : hiddenContainerClassName}>
                                    {activeScreenShare && <MediaFullScreen activeScreenShareStream={props.screenShareStreams[0]} />}
                                </Stack.Item>
                            )}
                            {/*<Stack.Item className={isMobile ? "ScreenSection":""} grow styles={activeScreenShare ? activeContainerClassName : hiddenContainerClassName}>*/}
                            {/*    {activeScreenShare && <MediaFullScreen activeScreenShareStream={props.screenShareStreams[0]} />}*/}
                            {/*</Stack.Item>*/}
                            {/*<Stack.Item className={isMobile ? "UserSection" : ""} grow styles={!activeScreenShare ? activeContainerClassName : hiddenContainerClassName}>*/}
                            <Stack.Item className={isMobile ? "UserSection" : ""} grow styles={activeContainerClassName}>
                                <MediaGallery localVideoStream={props.localVideoStream} isActiveScreenShare={activeScreenShare} activeScreenShareStream={props.screenShareStreams[0]} />
                            </Stack.Item>
                            {selectedPane !== CommandPanelTypes.None &&
                                (window.innerWidth > Constants.MINI_HEADER_WINDOW_WIDTH ? (
                                <Stack.Item id="RightDiv" disableShrink styles={paneStyles} style={{ width: '21.375rem', display: selectedPane == CommandPanelTypes.Chat?"none":"block"  }}>
                                        <CommandPanel {...props} selectedPane={selectedPane} setSelectedPane={setSelectedPane} />
                                    </Stack.Item>
                                ) : (selectedPane !== CommandPanelTypes.Chat && selectedPane !== CommandPanelTypes.ProblemStatement && selectedPane !== CommandPanelTypes.Ratings ? (
                                    <Overlay styles={overlayStyles}>
                                        <CommandPanel {...props} selectedPane={selectedPane} setSelectedPane={setSelectedPane} />
                                    </Overlay>
                                ) : (selectedPane === CommandPanelTypes.Ratings || selectedPane === CommandPanelTypes.ProblemStatement) ? (
                                    <CommandPanel {...props} selectedPane={selectedPane} setSelectedPane={setSelectedPane} />
                                ) : (<div style={{ display: 'none' }}> </div>)))}
                        </Stack>
                    )
                }
            </Stack.Item>
        </Stack>
    );
};
